import {Component} from "./Component";
import {addClass, hasParent, removeClass} from "../util/dom";
import {createLogger} from "../util/logger";
import {delayPromise} from "../util/promise";
import {fetchPage} from "../util/ajax";

const console = createLogger("FetchUrl");

/**
 * Fetches a url when an element is clicked and replaces the received html contents on page.
 * Configure:
 * data-target - The elements selector on page to replace content of
 * data-source - Optional source element selector to filter response
 * data-url - Optional url when no href or value in data-module-fetch-url is given
 */
export class FetchUrl extends Component {
    static name = "fetch-url";

    constructor(el) {
        super(el);

        /**
         * The target elements selector to replace content of
         * @type {string}
         */
        this.target = this.el.getAttribute("data-target");

        /**
         * The source elements selector in the received response
         * @type {string}
         */
        this.source = this.el.getAttribute("data-source");

        /**
         * Reference to target element
         * @type {HTMLElement}
         */
        this.$targetEl = document.querySelector(this.target);

        /**
         * @type {boolean}
         */
        this.isAppend = this.el.hasAttribute("data-append");

        this.addEventListener(document.body, "click", this.onClick.bind(this));
    }

    /**
     * @param {MouseEvent} e
     */
    onClick(e) {
        // Skip when clicking other elements
        if (!hasParent(e.target, this.el)) return;

        e.preventDefault();

        const url = this.el.hasAttribute("href")
            ? this.el.getAttribute("href")
            : this.el.getAttribute("data-module-" + this.name);

        addClass(document.body, "fetch-url--pending");

        delayPromise(300, fetchPage(url).then((child) => {
            if (!this.$targetEl) return;

            console.log("child", child);

            if (this.source) {
                child = child.querySelectorAll(this.source);
            }

            if (child) {
                if (this.isAppend) {
                    this.$targetEl.append(...child);
                } else {
                    this.$targetEl.replaceChildren(child);
                }
            }
        })).then(() => {
            removeClass(document.body, "fetch-url--pending");
        });




    }

}
